// removed by extract-text-webpack-plugin
module.exports = {"productionTitle":"_2XlpzvV05SLWDLPhBBVM8_","productionSection":"_31bpE2RaKebsXzhgkT7cnK","expandable":"_1v7hU9b5O0dc3dsHq4V8w0","expanded":"xjJMRc2CNQG23JqKTeMnl","expand":"B-y8ERW0r-Pux6W1gPIt8","products":"_1iVxa0viTn43vc6yXbaGCK","count":"TjxWbt5IZQv_vCW9g_Hza","productionRow":"_3MvA2KQ9PseT7088qaBEjo","invoiceId":"_3hP81RQYKsU2lVmioKf5jX","productionExport":"_3ai_SMqamkx7JhCM8B8tHW"};


//////////////////
// WEBPACK FOOTER
// ./app/widgets/ProductionQueueDistributor/widget.scss
// module id = 1228
// module chunks = 0